document.addEventListener("cart:open", handleCartEvents);
document.addEventListener("cart:updated", handleCartEvents);
const quoteRequestModal = document.querySelector("#quote-request-modal");

async function handleCartEvents(event) {
    debugger;
  const cartElement = event.target.querySelector("#CartDrawer");
  const checkOutBtn = cartElement?.querySelector("button[name='checkout']");
  const draftCheckOutBtn = cartElement?.querySelector("button[name='draft-checkout']");
  
  if(cartElement?.querySelector("div.weight-error-message")){
      cartElement?.querySelector("div.weight-error-message").remove();
  }

  draftCheckOutBtn.addEventListener('click', function(){ openQuoteRequestModel(); });

  const {totalWeight} = await getCart();
  if(checkOutBtn){
    const CheckOutBtnContainer = checkOutBtn.closest('form').closest('div');

    if(totalWeight > FoxTheme.quoteOrder.max_cart_weight){
      checkOutBtn.style.display="none";
      draftCheckOutBtn.style.display="inline-flex";
      const newErrorEl = document.createElement('div');
      newErrorEl.classList.add('weight-error-message');

      const svgString = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="error-icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
        `;

        // Parse the SVG string into a document
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgString, "image/svg+xml");

        // Get the SVG element
      const svgElement = doc.documentElement;
      newErrorEl.appendChild(svgElement);

      let p = document.createElement('p');
      p.textContent = FoxTheme.quoteOrder.message.replace("<p>", "").replace("</p>","");
      newErrorEl.appendChild(p);

      CheckOutBtnContainer.insertBefore(newErrorEl, checkOutBtn.closest('form'));
      
    }else{
      checkOutBtn.style.display="inline-flex";
      draftCheckOutBtn.style.display="none";
    }

  }
  
}

async function getCart(){
    const response = await fetch('/cart.js');
    if(!response.ok){
        console.error('Error fetching cart data !!');
        return;
    }
    const cart = await response.json();
    // console.log("Cart :", cart);
    const totalWeight = (cart.total_weight / 453.592).toFixed(2);;
    // console.log(`totalWeight : ${totalWeight} lbs`);
    return {cart, totalWeight};
}

async function clearCart(){
    const response = await fetch('/cart/clear.js');
    if(!response.ok){
        console.error('Error clearing cart data !!');
        return;
    }
    const cart = await response.json();
}


function openQuoteRequestModel(){
    quoteRequestModal.querySelector('#modalForm').style.display="flex";
    quoteRequestModal.querySelector('.quote-submit-message').style.display="none";
    quoteRequestModal.style.display = 'flex';
}

function closeQuoteRequestModel(){
    quoteRequestModal.style.display = 'none';    
}

window.addEventListener('click', (e) => {
    if (e.target === quoteRequestModal) {
        closeQuoteRequestModel(quoteRequestModal)
    }
});

quoteRequestModal.querySelector('#closeModalBtn').addEventListener('click', () => {
    quoteRequestModal.style.display = 'none';
});

quoteRequestModal.querySelector("#modalForm").addEventListener("submit", async function(event){
    event.preventDefault();
    const {cart} = await getCart();
    const formData = new FormData(event.target);
    const email = formData.get('email');
    const note = formData.get('note');
    const response = await fetch('https://brandography-dev.dreamhosters.com/minmor/create-draft-order.php', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({email,cart,note})
    });
    if(!response.ok){
        console.error("Error creating draft order !!");
        return;
    }
    const result = await response.json();
    if(result.data.draftOrderCreate.draftOrder){
        quoteRequestModal.querySelector('#modalForm').style.display="none";
        quoteRequestModal.querySelector('.quote-submit-message').style.display="flex";        
    }
});
